
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'brand.asia365': `Kuoni Specialist asia365`,
'brand.dorado': `Kuoni Specialist Dorado Latin Tours`,
'brand.kontiki': `Kuoni Specialist Kontiki Reisen`,
'brand.kuoni': `Kuoni Reisen`,
'brand.manta': `Kuoni Specialist Manta Reisen`,
'brand.privatesafaris': `Kuoni Specialist Private Safaris`,
'h5525336a2a7d8957': html`Abreisedaten &amp; Preise`,
's0e5d59a511871fea': `Reise anfragen`,
's0f7dc76026813d39': `pro Person`,
's296166c7f23d13fd': `Gruppengröße`,
's2b9f7cfbe1b6b1e6': `Sprachen`,
's3391fc7962b4683a': `ab`,
's57ca97c2f0a4c6b5': `Reisedauer`,
's62033155aecbb40d': `Veranstaltet von`,
's671825922220383a': `Rundreisenart`,
's85290b4f5c072c6d': `Start/Ziel`,
's9e2f88fd1529caef': `Startpunkt`,
'sbbe5bcf68495ce1e': `Angebot anfragen`,
'sd3b625485ff04ca8': `Zum nächstmöglichen Abreisetermin`,
'sd98f9b1f87289338': `Preis pro Person in`,
'sf6b408446d496c60': `Weiter ohne Datum`,
'sfd47ac0846790fd8': `Beste Reisezeit`,
'he43b6d98cfbb1dd0': html`calendarInfoText <a href="tel:${0}">${1}</a>`,
    };
  